import { gql } from '@apollo/client';

export const GET_THREE_SHAPE_AUTH_URL = gql`
  query getThreeShapeAuthUrl($input: ThreeShapeUrlInput!) {
    getThreeShapeAuthUrl(input: $input) {
      authUrl
      endSessionUrl
    }
  }
`;

export const GET_THREE_SHAPE_END_SESSION_URL = gql`
  query getThreeShapeEndSessionUrl($input: ThreeShapeUrlInput!) {
    getThreeShapeEndSessionUrl(input: $input) {
      authUrl
      endSessionUrl
    }
  }
`;

export const GET_THREE_SHAPE_CASES = gql`
  query getThreeShapeCases($input: ThreeShapeCasesInput!) {
    getThreeShapeCases(input: $input) {
      edges {
        id
        patientName
        orderNumber
        createdAt
        description
        attachments
      }
      hasNext
    }
  }
`;

export const GET_THREE_SHAPE_CASE_FILES_DOWNLOAD_LINK = gql`
  query getThreeShapeCaseFilesDownloadLink($caseId: String!) {
    getThreeShapeCaseFilesDownloadLink(caseId: $caseId) {
      presignedUrl
    }
  }
`;

export const EXPORT_THREE_SHAPE_SCANS = gql`
  mutation exportThreeShapeScans($input: ExportThreeShapeScansInput!) {
    exportThreeShapeScans(input: $input) {
      presignedUrl
      isTriggered
    }
  }
`;

export const IS_THREE_SHAPE_SCANS_UPLOAD_COMPLETED = gql`
  query isThreeShapeScansUploadCompleted(
    $caseId: String!
    $treatmentId: String
    $referralId: String
  ) {
    isThreeShapeScansUploadCompleted(
      caseId: $caseId
      treatmentId: $treatmentId
      referralId: $referralId
    )
  }
`;
